import { useState } from "react";
import {
  ArrowLongRightIcon,
  ArrowLongLeftIcon,
  CheckIcon,
} from "@heroicons/react/24/solid";
import CompleteIcon from "assets/images/complete.png";
import { useQuizContent, useSaveAnswersMutation } from "./QuizQuery";

function QuizContent() {
  const [quizNo, setQuizNo] = useState<number>(0);
  const [hasFieldError, setHasFieldError] = useState<Boolean>(false);
  const [fieldErrorText, setFieldErrorText] = useState<String>("");
  const [answer, setAnswer] = useState<{ [key: string]: any }>({
    answers: {},
    quiz_id: 40,
  });
  const { isLoading, error, data, isFetching } = useQuizContent(40);
  const [hasSuccessfullySubmitted, setHasSuccessfullySubmitted] =
    useState<Boolean>(false);
  const saveAnswersMutation = useSaveAnswersMutation(
    setHasSuccessfullySubmitted,
    setHasFieldError,
    setFieldErrorText
  );
  if (isLoading) {
    return <div>加载中...</div>;
  }

  const goBack = () => {
    setQuizNo(quizNo - 1);
  };

  const goNext = () => {
    setHasFieldError(false);
    setFieldErrorText("");
    if (data[quizNo].optional === false) {
      if (
        answer["answers"][data[quizNo].id] !== undefined &&
        answer["answers"][data[quizNo].id] !== "" &&
        answer["answers"][data[quizNo].id].length !== 0
      ) {
        setQuizNo(quizNo + 1);
      } else if (
        answer["answers"][data[quizNo].id] === undefined ||
        answer["answers"][data[quizNo].id] === "" ||
        answer["answers"][data[quizNo].id].length === 0
      ) {
        setHasFieldError(true);
        setFieldErrorText("必填项.");
      }
    } else if (data[quizNo].optional === true) {
      setQuizNo(quizNo + 1);
    }
  };

  const submitAllAnswer = () => {
    if (Object.keys(answer).length !== 0) {
      saveAnswersMutation.mutate(answer);
    }
  };

  const changeValue = (quizItemId: any, e: any) => {
    let newValue = e.currentTarget.value;
    setAnswer((prevState) => ({
      ...prevState,
      answers: { ...prevState.answers, [quizItemId]: newValue },
    }));
  };

  const changeCheckBoxValue = (quizItemId: any, e: any) => {
    // Destructuring
    let array = answer["answers"][data[quizNo].id] || [];
    const { value, checked } = e.currentTarget;

    if (checked) {
      // User checks the checkbox
      array.push(value);
    } else {
      // User unchecks the checkbox
      const tempArray = array;
      array = tempArray.filter((c: any) => {
        return c !== value;
      });
    }
    setAnswer((prevState) => ({
      ...prevState,
      answers: { ...prevState.answers, [quizItemId]: array },
    }));
  };

  return (
    <div className="border border-qpblue-100 rounded-lg mt-6 pt-8 md:pt-12 drop-shadow-sm bg-cover bg-[url('/public/images/quiz-bg.png')] bg-bottom">
      {!hasSuccessfullySubmitted ? (
        <>
          <div className="bg-qpblue-400 text-white inline-block rounded-tr-3xl rounded-br-3xl p-2 md:p-3 text-3xl px-16 md:px-16">
            {data[quizNo].id}/{data.length}
          </div>
          <div className="p-6 md:p-16">
            <h2 className="text-qpblue-400 text-lg md:text-3xl font-extrabold mb-4">
              {data[quizNo]["question_text_before"]}
              {data[quizNo]["question_text_after"]
                ? " " +
                  answer["answers"][data[quizNo].link_to] +
                  " " +
                  data[quizNo]["question_text_after"]
                : ""}
            </h2>
            <div className="mb-12">
              {data[quizNo]["question_type"] === "text" && (
                <>
                  <textarea
                    id="message"
                    rows={6}
                    className={`block p-2.5 w-full text-lg text-gray-900 bg-white rounded-lg border ${
                      !hasFieldError ? "border-gray-400" : "border-red-600"
                    } focus:ring-blue-500 focus:border-blue-500`}
                    placeholder="请在此输入..."
                    value={
                      answer["answers"][data[quizNo].id] !== undefined
                        ? answer["answers"][data[quizNo].id]
                        : ""
                    }
                    onChange={(e) => changeValue(data[quizNo].id, e)}
                  />
                </>
              )}
              {data[quizNo]["question_type"] === "yes_no" && (
                <ul>
                  <li className="mb-2">
                    <input
                      type="radio"
                      className="form-radio bg-white border-gray-900 p-3"
                      name="yesnoInput"
                      id="yes"
                      value="yes"
                      onChange={(e) => changeValue(data[quizNo].id, e)}
                    />
                    <label htmlFor="yes" className="ml-2 text-md md:text-xl ">
                      是
                    </label>
                  </li>
                  <li className="mb-2">
                    <input
                      type="radio"
                      className="form-radio bg-white border-gray-900 p-3"
                      name="yesnoInput"
                      id="no"
                      value="no"
                      onChange={(e) => changeValue(data[quizNo].id, e)}
                    />
                    <label htmlFor="no" className="ml-2 text-md md:text-xl">
                      不是
                    </label>
                  </li>
                </ul>
              )}
              {data[quizNo]["question_type"] === "selection" && (
                <ul>
                  {data[quizNo]["selection_question_detail"].selections.map(
                    (selection: any) => {
                      return (
                        <li
                          key={selection.selection_content}
                          className="text-md md:text-xl text-gray-800 mb-3"
                        >
                          <input
                            type="checkbox"
                            className="bg-white border-gray-900 text-gray-900 rounded-sm focus:border-gray-900 p-3 mr-2"
                            value={selection.selection_content}
                            onChange={(e) =>
                              changeCheckBoxValue(data[quizNo].id, e)
                            }
                            checked={
                              answer["answers"][data[quizNo].id] !== undefined
                                ? answer["answers"][data[quizNo].id].includes(
                                    selection.selection_content
                                  )
                                : false
                            }
                            id={selection.selection_content}
                          />
                          <label htmlFor={selection.selection_content}>
                            {selection.selection_content}
                          </label>
                        </li>
                      );
                    }
                  )}
                </ul>
              )}
              <div className="text-red-400 italic">{fieldErrorText}</div>
            </div>
            <div className="text-center">
              {!saveAnswersMutation.isLoading ? (
                <>
                  {data[quizNo].id !== 1 && (
                    <button
                      type="button"
                      className=" text-gray-800 bg-white border border-gray-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 mr-2 mb-2"
                      onClick={() => goBack()}
                    >
                      <ArrowLongLeftIcon className="w-6 h-6 inline -mt-1" />{" "}
                      <span>上一个</span>
                    </button>
                  )}
                  {data[quizNo].id >= data.length ? (
                    <button
                      type="button"
                      className=" text-white bg-qpblue-400 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                      onClick={() => submitAllAnswer()}
                    >
                      <CheckIcon className="w-6 h-6 inline -mt-1 mr-1" />
                      <span>提交</span>{" "}
                    </button>
                  ) : (
                    <button
                      type="button"
                      className=" text-white bg-qpblue-400 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
                      onClick={() => goNext()}
                    >
                      <span>下一个</span>{" "}
                      <ArrowLongRightIcon className="w-6 h-6 inline -mt-1 mr-1" />
                    </button>
                  )}
                </>
              ) : (
                <button
                  type="button"
                  className="text-gray-700 cursor-progress bg-gray-100 border border-gray-800 font-medium rounded-lg text-lg px-5 py-2.5 mr-2 mb-2"
                >
                  <span>提交中...</span>{" "}
                </button>
              )}
            </div>
          </div>
        </>
      ) : (
        <div className="pb-16 text-center">
          <img
            src={CompleteIcon}
            className="cursor-pointer w-24 mx-auto"
            alt="Complete"
          />
          <h2 className="text-xl md:text-3xl uppercase text-qpblue-400 font-black text-center mt-4">
            提交成功!
          </h2>
          <p className="text-center mt-6 font-extrabold text-gray-600">
            我们已经收到您的咨询,
            <br />
            将会尽快与您联系, 谢谢您.
          </p>
          <br />
          <a
            href="/"
            className="text-white bg-qpblue-400 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-lg px-5 py-2.5 mr-2 mb-2 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800"
          >
            <span>返回我们的网站</span>
          </a>
        </div>
      )}
    </div>
  );
}

export default QuizContent;
